export default __webpack_public_path__ + "static/media/22.f4a6dfe8.jpg";